import React, { useState } from 'react';
import './Navbar.css'; 

// Removed { onOpenContact } as it is no longer needed
const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  // Function to handle smooth scrolling to the contact section
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false); // Close mobile menu if open
  };

  return (
    <nav className="navbar-container">
      {/* --- Logo Section --- */}
      <a href="#home" className="navbar-logo">
        <img 
          src="/logo.png" 
          alt="Sry Interiors Logo" 
          className="logo-image" 
        />
      </a>

      {/* --- Navigation Links --- */}
      <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
        <a href="#home" className="nav-link" onClick={() => setIsOpen(false)}>HOME</a>
        <a href="#services" className="nav-link" onClick={() => setIsOpen(false)}>SERVICES</a>
        <a href="#portfolio" className="nav-link" onClick={() => setIsOpen(false)}>PORTFOLIO</a>
        <a href="#blog" className="nav-link" onClick={() => setIsOpen(false)}>BLOG</a>
        
        {/* Mobile Button - Scrolls to Contact */}
        <button 
          className="mobile-cta" 
          onClick={scrollToContact}
        >
          REQUEST A CONSULTATION
        </button>
      </div>

      {/* Desktop Button - Scrolls to Contact */}
      <div className="navbar-cta">
        <button onClick={scrollToContact}>
          REQUEST A CONSULTATION
        </button>
      </div>

      {/* Mobile Menu Toggle */}
      <div className="mobile-toggle" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </nav>
  );
};

export default NavBar;